import { type ErrorComponentProps, Link, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { describeError } from '@/shared/api/errors';
import { ErrorAlert } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';
import { Spinner } from '@/shared/ui/misc';

import { reportError } from './error-reporting';

/** Shown when a route fails to load or render; includes the reference ID (UX-4). */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    reportError(error);
  }, [error]);
  const { title, detail, reference } = describeError(error);
  return (
    <div className="mx-auto flex max-w-lg flex-col gap-4 p-6">
      <ErrorAlert title={title} reference={reference}>
        {detail}
      </ErrorAlert>
      <div>
        <Button
          variant="secondary"
          onClick={() => {
            void router.invalidate();
          }}
        >
          Try again
        </Button>
      </div>
    </div>
  );
}

export function RoutePending() {
  return (
    <div className="flex h-full items-center justify-center p-10">
      <Spinner />
    </div>
  );
}

export function NotFound() {
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-3 p-10 text-center">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-muted-foreground">The address may be wrong, or the page was moved.</p>
      <Link to="/" className="text-primary hover:underline">
        Go home
      </Link>
    </div>
  );
}
